import { useMemo, useState } from 'react';
import { InlineGrid } from '@shopify/polaris';
import { CustomCard, StrategyCallModal } from '@/components';
import { useStrategyCallEligibility } from '@/hooks';
import { HeadsetIcon } from '@/icons';
import { helpCenterData } from './config';
import HelpCard, { HelpCenterCardProps } from './components/HelpCenterCard';

const HelpCenter = () => {
  // TR-480: shop đủ điều kiện (orderCountLastMonth >= 300) mới thấy tile "1:1 Strategy Call".
  const { isEligible } = useStrategyCallEligibility();
  const [isStrategyModalOpen, setIsStrategyModalOpen] = useState(false);

  const items: HelpCenterCardProps[] = useMemo(() => {
    if (!isEligible) return helpCenterData;
    // TR-480 (Figma node 1208-7593): tile "1:1 Strategy Call" đứng ĐẦU, highlight viền xanh, icon headset.
    return [
      {
        icon: <HeadsetIcon />,
        title: '1:1 Strategy Call',
        description: 'Find suitable solutions with your needs',
        onClick: () => setIsStrategyModalOpen(true),
        highlighted: true,
      },
      ...helpCenterData,
    ];
  }, [isEligible]);

  // Grid co/giãn theo số tile: 3 khi không eligible, 4 khi eligible (TR-480 — grid co lại khi ẩn tile).
  const columnCount = items.length;

  return (
    <>
      <CustomCard title="Help center">
        <InlineGrid columns={{ xs: 1, sm: 1, md: 1, lg: columnCount, xl: columnCount }} gap="400">
          {items.map(({ icon, title, description, url, onClick, highlighted }, index) => (
            <HelpCard key={index} icon={icon} title={title} description={description} url={url} onClick={onClick} highlighted={highlighted} />
          ))}
        </InlineGrid>
      </CustomCard>
      <StrategyCallModal open={isStrategyModalOpen} onClose={() => setIsStrategyModalOpen(false)} />
    </>
  );
};

export default HelpCenter;
